import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Working from '@totem/components/ui_components/pageExceptions/working/working';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import { securityGroupCheckConstraintAny } from '@totem/components/userContext/security/userUtilities';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { isNotNull } from '@totem/utilities/common';

const UserHome = () => {
  const { userProfile } = useContext(UserProfileContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (permissions.vendor.hasPermissions(userProfile)) {
      navigate('/dashboard/myWork', { replace: true });
      return;
    }

    if (
      isNotNull(userProfile) &&
      isNotNull(userProfile.preferences) &&
      isNotNull(userProfile.preferences.homePage)
    ) {
      switch (userProfile.preferences.homePage) {
        case 'home':
          navigate('/dashboard/home', { replace: true });
          return;
        case 'myDashboard':
          navigate('/dashboard/home', { replace: true });
          return;
        case 'overview':
          navigate('/dashboard/portfolio', { replace: true });
          return;
        case 'optimize':
          if (
            permissions.optimize.hasPermissions(
              userProfile,
              securityGroupCheckConstraintAny,
            )
          ) {
            navigate('/dashboard/optimize', { replace: true });
            return;
          }
          break;
        case 'remote-access-dashboard':
          if (permissions.remoteAccess.hasPermissions(userProfile)) {
            navigate('/dashboard/remoteAccessDashboard', { replace: true });
            return;
          }
          break;
        case 'asset-inventory':
          if (
            permissions.assetInventory.hasPermissions(
              userProfile,
              securityGroupCheckConstraintAny,
            )
          ) {
            navigate('/dashboard/assetInventory', { replace: true });
            return;
          }
          break;
        case 'backups':
          if (
            permissions.continuity.hasPermissions(
              userProfile,
              securityGroupCheckConstraintAny,
            )
          ) {
            navigate('/dashboard/deviceBackups', { replace: true });
            return;
          }
          break;
        default:
          navigate('/dashboard/portfolio', { replace: true });
          return;
      }
    }

    navigate('/dashboard/portfolio', { replace: true });
  }, []);

  return (
    <Working
      subTitle={'Checking your preferred home page'}
      continueLink={'/dashboard/portfolio'}
      continueText={'Continue to Portfolio'}
    />
  );
};

export default UserHome;
